import { Trans, useTranslation } from 'react-i18next';

import Button from '../../../components/buttons/Button';

export const RewardsTooltip = (props: { handleClick: VoidFunction }) => {
  const { t } = useTranslation();
  return (
    <>
      <p data-testid="onboarding-rewards-tooltip-text">
        <Trans
          components={{
            intro: <span />,
            rewards: <strong />,
            middle: <span />,
            free: <strong />,
            outro: <span />,
          }}
          i18nKey="rewards.checkOutRewards"
        />
      </p>
      <Button btnType="main" onClick={props.handleClick}>
        {t('common.exciting')}
      </Button>
    </>
  );
};
